module.exports = __webpack_public_path__ + "a18057593ac73da19f37ca97f5b3f47d.pdf";